import axios, { getData } from "lib/axios";

export const checkEmail = async (data) => {
  return axios.post("/pre-signup/email-check", data).then(getData);
};
export const loginPassword = async (data) => {
  return axios.post("/pre-signup/login", data).then(getData);
};
export const userRegister = async (data) => {
  return axios.post("/pre-signup/register", data).then(getData);
};
export const verifyEmailParams = async (params) => {
  return axios.get(`/signup/verify${params}`).then(getData);
};

export const registerOrganisation = async (data) => {
  return axios.post("/signup/organisation", data).then(getData);
};

export const adminSignUp = async (data) => {
  return axios.post("/signup/admin", data).then(getData);
};
